import userService from '../helpers/user.service'
import router from '../router'
import store from './index'

const token = localStorage.getItem('token')
const info = JSON.parse(localStorage.getItem('info'))
const role = JSON.parse(localStorage.getItem('role'))
const wfRole = JSON.parse(localStorage.getItem('wfRole'))
const state = () => {
  return {
    token: token || null,
    info: info || null,
    role: role || null,
    wfRole: wfRole || [],
    loggeduser: token === true,
    loginRequire: false
  }
}

const getters = {
  checkDocOwner(state) {
    return employeeID => employeeID == state.info.employeeId
  },
  checkAccountHead(state) {
    return compNo => {
      return state.wfRole.find(
        item => item.comp_no === compNo && item.role_code == 'Account_Head'
      )
    }
  },
  checkPurchaseHead(state) {
    return compNo => {
      return state.wfRole.find(
        item => item.comp_no === compNo && item.role_code == 'Purchase_Head'
      )
    }
  },
  checkPurchaseAdmin(state) {
    return compNo => {
      return state.wfRole.find(
        item => item.comp_no === compNo && item.role_code == 'Purchase_Admin'
      )
    }
  },
  checkPurchaseReview(state) {
    return compNo => {
      return state.wfRole.find(
        item => item.comp_no === compNo && item.role_code == 'Purchase_Review'
      )
    }
  },
  checkFinanceAdmin(state) {
    return compNo => {
      return state.wfRole.find(
        item => item.comp_no === compNo && item.role_code == 'Finance_Admin'
      )
    }
  }
}

const mutations = {
  loginSuccess(state, data) {
    // console.log(data.data.userInfo)
    state.token = data.data.accessToken
    state.info = {
      employeeId: data.data.userInfo.employee_id,
      fullname: data.data.userInfo.fullname_th,
      username: data.data.userInfo.username,
      comp_no: data.data.userInfo.comp_no,
      employeeImage: data.data.userInfo.employee_image,
      role: data.data.userInfo.role_code_array,
      bu_no: data.data.userInfo.bu_no,
      bu_name: data.data.userInfo.bu_name,
      section: data.data.userInfo.section,
      department: data.data.userInfo.department,
      division: data.data.userInfo.division,
      telephone: data.data.userInfo.telephone,
      showTabMonitor: data.data.showTabMonitor,
      roleCode: data.data.userRole.role_code
    }
    state.role = data.data.userRole
    state.wfRole = data.data.wfRolesMember
    state.loggeduser = true
  },
  logout(state, rootState) {
    state.token = null
    state.info = null
    state.role = null
    state.loggedduser = false
    state.wfRole = []
    this.state.pv.docStatusOption = []
    this.state.ca.docStatusOption = []
    this.state.cl.docStatusOption = []
    this.state.pr.docStatusOption = []
    this.state.po.docStatusOption = []
    this.state.gr.docStatusOption = []
    this.state.of.docStatusOption = []
    this.state.rf.docStatusOption = []
  },
  loginRequire(state, data) {
    state.loginRequire = data
  }
}

const actions = {
  login({ commit }, { email, password }) {
    commit('loginRequire', true)
    userService
      .login(email, password)
      .then(res => {
        commit('loginRequire', false)
        if (res.code == 200) {
          commit('loginSuccess', res)
          router.push('/modules/all')
        } else {
          store.dispatch('notification/error', res.message)
        }
      })
      .catch(error => {
        commit('loginRequire', false)
        store.dispatch('notification/error', error.message)
      })
  },
  async logout({ commit, state }) {
    await userService.logout(state.token, state.info)
    // store.commit('global/setInit')
    commit('logout')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
